import { Link as RouterLink, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import useAuth from 'src/hooks/useAuth';
import {
  AppBar,
  Box,
  Button,
  Divider,
  Toolbar,
  // Hidden,
  // Typography,
  Link,
  makeStyles,
  ButtonBase,
  Avatar,
  Hidden,
  Typography,
  Menu,
  MenuItem,
  Container,
  IconButton,
  SvgIcon,
  Drawer,
  List,
  ListItem,
} from '@material-ui/core';
import { useState, useRef } from 'react';
import { NavHashLink } from 'react-router-hash-link';
import { Menu as MenuIcon } from 'react-feather';

// import { APP_VERSION } from 'src/config';
// import Logo from 'src/components/Logo';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    zIndex: theme.zIndex.drawer + 100,
  },
  toolbar: {
    height: 64,
  },
  logo: {
    marginRight: theme.spacing(2),
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
    '& + &': {
      marginLeft: theme.spacing(2),
    },
  },
  button: {
    marginLeft: theme.spacing(1),
  },
  divider: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1),
  },
  popover: {
    width: 200,
  },
}));

function TopNavBar({ className, ...rest }) {
  const classes = useStyles();
  const { isAdmin, isAuthenticated, profile, logout } = useAuth();
  const [isOpen, setOpen] = useState(false);
  const ref = useRef(null);
  const currentLocation = useLocation();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const { user } = useAuth();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      {/* <PerfectScrollbar options={{ suppressScrollX: true }}> */}

      {profile && (
        <>
          <Box p={2}>
            <Box display="flex" justifyContent="center">
              <RouterLink to="/app/account">
                <Avatar
                  alt="User"
                  className={classes.avatar}
                  // src={profile.image}
                />
              </RouterLink>
            </Box>
            <Box mt={2} textAlign="center">
              <Link
                component={RouterLink}
                to="/app/account"
                variant="h5"
                color="textPrimary"
                underline="none"
              >
                {profile.firstName} {profile.lastName}
              </Link>
              <Typography variant="body2" color="textSecondary">
                Status: {user.isAdmin ? 'Admin' : 'Competitor'}
              </Typography>
            </Box>
          </Box>
          <Divider />
        </>
      )}
      <Box p={2}>
        <List>
          <ListItem>
            <Link
              className={classes.link}
              color="textPrimary"
              component={NavHashLink}
              underline="none"
              variant="body2"
              smooth
              to={currentLocation.pathname === '/' ? '/#home' : '/'}
            >
              Home
            </Link>
          </ListItem>
          <ListItem>
            <Link
              className={classes.link}
              color="textPrimary"
              component={NavHashLink}
              underline="none"
              variant="body2"
              smooth
              to="/#events"
            >
              Events
            </Link>
          </ListItem>

          {isAdmin && (
            <>
              <ListItem>
                <Link
                  className={classes.link}
                  color="textPrimary"
                  component={RouterLink}
                  to="/app"
                  underline="none"
                  variant="body2"
                >
                  Dashboard
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  className={classes.link}
                  color="textPrimary"
                  component={RouterLink}
                  to="/app/event/create-event"
                  underline="none"
                  variant="body2"
                >
                  Create Event
                </Link>
              </ListItem>
            </>
          )}

          {!profile && (
            <>
              <br />
              <Divider />
              <br />
              <ListItem>
                <Button
                  color="primary"
                  component={RouterLink}
                  to="/login"
                  variant="contained"
                  size="small"
                >
                  Log in
                </Button>
              </ListItem>
              <ListItem>
                <Button
                  // className={classes.button}
                  color="secondary"
                  component={RouterLink}
                  to="/signup"
                  variant="contained"
                  size="small"
                >
                  Sign Up
                </Button>
              </ListItem>
            </>
          )}
        </List>
      </Box>
      <Divider />
    </Box>
  );

  return (
    <AppBar className={clsx(classes.root, className)} color="default" {...rest}>
      <Container maxWidth="lg">
        <Toolbar className={classes.toolbar}>
          {/* <RouterLink to="/">WRESM</RouterLink> */}

          <Link
            className={classes.link}
            color="textPrimary"
            component={RouterLink}
            to="/"
            underline="none"
            variant="h4"
          >
            WRESMNR
          </Link>
          {/* <Hidden mdDown>
            <Typography variant="caption" color="textSecondary">
              Version
            </Typography>
          </Hidden> */}
          <Box flexGrow={1} />
          <Hidden xsDown>
            <Link
              className={classes.link}
              color="textPrimary"
              component={NavHashLink}
              underline="none"
              variant="body2"
              smooth
              to={currentLocation.pathname === '/' ? '/#home' : '/'}
            >
              Home
            </Link>
            <Link
              className={classes.link}
              color="textPrimary"
              component={NavHashLink}
              underline="none"
              variant="body2"
              smooth
              to="/#events"
            >
              Events
            </Link>

            {isAdmin && (
              <>
                <Link
                  className={classes.link}
                  color="textPrimary"
                  component={RouterLink}
                  to="/app"
                  underline="none"
                  variant="body2"
                >
                  Dashboard
                </Link>
                <Link
                  className={classes.link}
                  color="textPrimary"
                  component={RouterLink}
                  to="/app/event/create-event"
                  underline="none"
                  variant="body2"
                >
                  Create Event
                </Link>
              </>
            )}

            <Divider className={classes.divider} />

            {isAuthenticated ? (
              <>
                <Box
                  display="flex"
                  alignItems="center"
                  component={ButtonBase}
                  onClick={handleOpen}
                  ref={ref}
                >
                  <Avatar
                    alt="User"
                    className={classes.avatar}
                    // src={user.avatar}
                  />
                  <Hidden smDown>
                    <Typography variant="h6" color="inherit">
                      {profile.firstName} {profile.lastName}
                    </Typography>
                  </Hidden>
                </Box>
                <Menu
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  keepMounted
                  PaperProps={{ className: classes.popover }}
                  getContentAnchorEl={null}
                  anchorEl={ref.current}
                  open={isOpen}
                >
                  {/* <MenuItem component={RouterLink} to="/app/social/profile">
              Profile
            </MenuItem> */}
                  <MenuItem
                    component={RouterLink}
                    to={`/${isAdmin ? 'app' : 'user'}/account`}
                  >
                    Account
                  </MenuItem>
                  <MenuItem onClick={logout}>Logout</MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Button
                  color="primary"
                  component={RouterLink}
                  to="/login"
                  variant="contained"
                  size="small"
                >
                  Log in
                </Button>
                <Button
                  className={classes.button}
                  color="secondary"
                  component={RouterLink}
                  to="/signup"
                  variant="contained"
                  size="small"
                >
                  Sign Up
                </Button>
              </>
            )}
          </Hidden>
          <Hidden smUp>
            <IconButton color="inherit" onClick={() => setMobileNavOpen(true)}>
              <SvgIcon fontSize="small">
                <MenuIcon />
              </SvgIcon>
            </IconButton>
          </Hidden>
          <Drawer
            anchor="right"
            classes={{ paper: classes.mobileDrawer }}
            onClose={() => setMobileNavOpen(false)}
            open={isMobileNavOpen}
            variant="temporary"
          >
            {content}
          </Drawer>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

TopNavBar.propTypes = {
  className: PropTypes.string,
};

export default TopNavBar;
